import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

/**
 * 買取屋 (kaitoriya) の各画面プレースホルダ。frontend はまだ未実装のため
 * 「準備中」を表示する枠のみ。backend 側 (jp.active.promotion.kaitoriya) の
 * スキーマは既に存在するため、画面は後日この枠に載せていく。
 */
@Component({
    standalone: false,
    selector: 'app-kaitoriya-placeholder',
    template: `
        <div class="container-fluid mt-4">
            <div class="card">
                <div class="card-body text-center text-muted py-5">
                    <i class="icon-basket" style="font-size:2.5rem"></i>
                    <h4 class="mt-3">{{ title | transloco }}</h4>
                    <p class="mb-0">{{ 'kaitoriya.under_construction' | transloco }}</p>
                </div>
            </div>
        </div>
    `,
})
export class KaitoriyaPlaceholderComponent {
    constructor(private route: ActivatedRoute) {
    }

    get title(): string {
        return (this.route && this.route.snapshot && this.route.snapshot.data && this.route.snapshot.data['title'])
            || 'kaitoriya.brand_name';
    }
}
